/// <reference path="../../../../shared-types/messages.d.ts" />

export type {
	BaseMessage,
	MessageToUXP,
	MessageToUXPHandlerEntry,
	RendererToUxpMessages,
} from "../../../../shared-types/message/to-uxp";

import type { MessageToUXP } from "../../../../shared-types/message/to-uxp";

export function isMessageToUXP(message: unknown): message is MessageToUXP {
	if (!message || typeof message !== "object") return false;
	const msg = message as { key?: unknown; id?: unknown };
	return typeof msg.key === "string" && typeof msg.id === "string";
}
